import { Record } from 'immutable';

const TaxEntityRecord = Record({
  countryCode: null,
  region: null,
  subRegion: null,
  postalCode: null,
  city: null
});

export class TaxEntity extends TaxEntityRecord {
  countryCode: string;
  region: string;
  subRegion: string;
  postalCode: string;
  city: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/TaxEntity.ts